__turbopack_context__.v({
  "center": "V4aI2q_center",
  "colorDecorator": "V4aI2q_colorDecorator",
  "h2": "V4aI2q_h2",
  "h3": "V4aI2q_h3",
  "h4": "V4aI2q_h4",
  "h5": "V4aI2q_h5",
  "h6": "V4aI2q_h6",
  "olList": "V4aI2q_olList",
  "p": "V4aI2q_p",
  "pExtraLarge": "V4aI2q_pExtraLarge",
  "pLarge": "V4aI2q_pLarge",
  "pMedium": "V4aI2q_pMedium",
  "pSmall": "V4aI2q_pSmall",
  "pTiny": "V4aI2q_pTiny",
  "right": "V4aI2q_right",
  "sectionHeader": "V4aI2q_sectionHeader",
  "strong": "V4aI2q_strong",
  "ulList": "V4aI2q_ulList",
});
